import { Flex, Text } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal.js';
import { ISubmissionMetadata } from '@publishing-engine/domain/models/submission.js';
import { FormFieldFunding } from '@publishing-engine/domain/types/article.js';
import { FundingEmptyState } from './FundingEmptyState.js';
import { FundingDisplay } from './FundingDisplay.js';

interface Props {
  value?: ISubmissionMetadata['funding'];
  previousValue?: ISubmissionMetadata['funding'];
  onClose: () => void;
  config: Omit<FormFieldFunding, 'component'>;
}

export const FundingDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = !!previousValue?.exists;
  const hasCurrent = !!value?.exists;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">
            {config.params.labels.section.title}
          </Text>
          <Text>{previousValue?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">{label} </Text>
          {!hasPrevious ? (
            <FundingEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FundingDisplay value={previousValue.value} />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">
            {config.params.labels.section.title}
          </Text>
          <Text>{value?.exists ? 'Yes' : 'No'}</Text>
          <Text textStyle="headingItem">{label} </Text>
          {!hasCurrent ? (
            <FundingEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FundingDisplay value={value.value} />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
